type Perk = {
  num: string;
  title: string;
  body: string;
};

const perks: Perk[] = [
  {
    num: "01",
    title: "Currently reading",
    body: "Always know what the club is on, when we meet, and what's coming up next.",
  },
  {
    num: "02",
    title: "Discussion feed",
    body: "Curated prompts and announcements from the hosts. Jump in and comment all month.",
  },
  {
    num: "03",
    title: "In-person meetups",
    body: "Once a month, somewhere good. Bring the book. We'll bring the snacks.",
  },
  {
    num: "04",
    title: "A directory of besties",
    body: "Faces and names of every woman in the club. No phones, no DMs — just recognition.",
  },
];

export default function WhatYouGet() {
  return (
    <section className="section">
      <div className="container">
        <div
          className="split split--5-7 split--end"
          style={{ marginBottom: "3rem" }}
        >
          <div>
            <div className="eyebrow">What you get</div>
            <h2
              className="display display--lg"
              style={{ marginTop: "1rem", marginBottom: 0 }}
            >
              your members-only
              <br />
              poolside.
            </h2>
          </div>
          <p className="lead" style={{ color: "var(--c-palm)" }}>
            Once you're in, the portal is yours. It's where the club lives between meetups.
          </p>
        </div>

        <ol
          style={{
            listStyle: "none",
            padding: 0,
            margin: 0,
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
            gap: "1.5rem",
          }}
        >
          {perks.map((p) => (
            <li
              key={p.num}
              style={{
                background: "var(--c-sand)",
                border: "1px solid var(--c-rule)",
                borderRadius: "var(--r-md)",
                padding: "1.75rem",
                boxShadow: "var(--shadow-soft)",
                position: "relative",
              }}
            >
              <div
                className="eyebrow"
                style={{ color: "var(--c-brass)", fontSize: "0.7rem" }}
              >
                {p.num}
              </div>
              <h3
                className="display display--sm"
                style={{
                  marginTop: "0.5rem",
                  marginBottom: "0.75rem",
                  fontStyle: "normal",
                }}
              >
                {p.title}
              </h3>
              <p style={{ margin: 0, lineHeight: 1.55 }}>{p.body}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
